// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdminAuth_overlay__Fu3Qe {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  backdrop-filter: blur(5px);
}

.AdminAuth_authContainer__79obj {
  background: white;
  border-radius: 16px;
  padding: 40px;
  width: 100%;
  max-width: 450px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: AdminAuth_slideIn__C6QWM 0.3s ease-out;
}

@keyframes AdminAuth_slideIn__C6QWM {
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
.AdminAuth_authHeader__yI1yv {
  text-align: center;
  margin-bottom: 30px;
}
.AdminAuth_authHeader__yI1yv h2 {
  margin: 0 0 8px 0;
  font-size: 24px;
  font-weight: 600;
  color: #1053ad;
}
.AdminAuth_authHeader__yI1yv p {
  margin: 0;
  color: #666;
  font-size: 14px;
  line-height: 1.5;
}

.AdminAuth_authForm__RZH5f {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.AdminAuth_formGroup__4Jh8C {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.AdminAuth_formGroup__4Jh8C label {
  font-weight: 600;
  color: #333;
  font-size: 14px;
}
.AdminAuth_formGroup__4Jh8C input {
  padding: 12px 16px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.3s ease;
  font-family: inherit;
}
.AdminAuth_formGroup__4Jh8C input:focus {
  outline: none;
  border-color: #1053ad;
  box-shadow: 0 0 0 3px rgba(16, 83, 173, 0.1);
}
.AdminAuth_formGroup__4Jh8C input::placeholder {
  color: #999;
}
.AdminAuth_formGroup__4Jh8C input:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
}

.AdminAuth_errorMessage__jEN-M {
  background-color: #fee;
  color: #d32f2f;
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid #ffcdd2;
  font-size: 14px;
  text-align: center;
  animation: AdminAuth_shake__WmIg2 0.5s ease-in-out;
}

@keyframes AdminAuth_shake__WmIg2 {
  0%, 100% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(-5px);
  }
  75% {
    transform: translateX(5px);
  }
}
.AdminAuth_buttonGroup__c\\+JYv {
  display: flex;
  gap: 12px;
  margin-top: 10px;
}

.AdminAuth_cancelButton__3-kq-, .AdminAuth_loginButton__AYQUx {
  flex: 1 1;
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}
.AdminAuth_cancelButton__3-kq-:disabled, .AdminAuth_loginButton__AYQUx:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}
.AdminAuth_cancelButton__3-kq-:hover:not(:disabled), .AdminAuth_loginButton__AYQUx:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.AdminAuth_cancelButton__3-kq- {
  background-color: #f5f5f5;
  color: #666;
  border: 2px solid #e0e0e0;
}
.AdminAuth_cancelButton__3-kq-:hover:not(:disabled) {
  background-color: #e0e0e0;
  color: #333;
}

.AdminAuth_loginButton__AYQUx {
  background-color: #1053ad;
  color: white;
}
.AdminAuth_loginButton__AYQUx:hover:not(:disabled) {
  background-color: #0d4494;
}
.AdminAuth_loginButton__AYQUx:disabled {
  background-color: #ccc;
}

.AdminAuth_authTip__3FXF4 {
  margin-top: 20px;
  padding: 12px;
  background-color: #f8f9fa;
  border-radius: 8px;
  border-left: 4px solid #1053ad;
}
.AdminAuth_authTip__3FXF4 p {
  margin: 0;
  font-size: 12px;
  color: #666;
  text-align: center;
}

@media (max-width: 480px) {
  .AdminAuth_authContainer__79obj {
    margin: 20px;
    padding: 30px 20px;
  }
  .AdminAuth_authHeader__yI1yv h2 {
    font-size: 20px;
  }
  .AdminAuth_buttonGroup__c\\+JYv {
    flex-direction: column;
    gap: 8px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/AdminAuth/index.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,0BAAA;AACF;;AAEA;EACE,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;EACA,0CAAA;EACA,iDAAA;AACF;;AAEA;EACE;IACE,UAAA;IACA,wCAAA;EACF;EACA;IACE,UAAA;IACA,iCAAA;EACF;AACF;AAEA;EACE,kBAAA;EACA,mBAAA;AAAF;AAEE;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAAJ;AAGE;EACE,SAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AADJ;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAFF;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAFF;AAIE;EACE,gBAAA;EACA,WAAA;EACA,eAAA;AAFJ;AAKE;EACE,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,oBAAA;AAHJ;AAKI;EACE,aAAA;EACA,qBAAA;EACA,4CAAA;AAHN;AAMI;EACE,WAAA;AAJN;AAOI;EACE,yBAAA;EACA,mBAAA;AALN;;AAUA;EACE,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,kDAAA;AAPF;;AAUA;EACE;IAAW,wBAAA;EANX;EAOA;IAAM,2BAAA;EAJN;EAKA;IAAM,0BAAA;EAFN;AACF;AAIA;EACE,aAAA;EACA,SAAA;EACA,gBAAA;AAFF;;AAKA;EACE,SAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AAFF;AAIE;EACE,mBAAA;EACA,YAAA;AAFJ;AAKE;EACE,2BAAA;EACA,0CAAA;AAHJ;;AAOA;EACE,yBAAA;EACA,WAAA;EACA,yBAAA;AAJF;AAME;EACE,yBAAA;EACA,WAAA;AAJJ;;AAQA;EACE,yBAAA;EACA,YAAA;AALF;AAOE;EACE,yBAAA;AALJ;AAQE;EACE,sBAAA;AANJ;;AAUA;EACE,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,8BAAA;AAPF;AASE;EACE,SAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;AAPJ;;AAYA;EACE;IACE,YAAA;IACA,kBAAA;EATF;EAaE;IACE,eAAA;EAXJ;EAeA;IACE,sBAAA;IACA,QAAA;EAbF;AACF","sourcesContent":[".overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 9999;\n  backdrop-filter: blur(5px);\n}\n\n.authContainer {\n  background: white;\n  border-radius: 16px;\n  padding: 40px;\n  width: 100%;\n  max-width: 450px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  animation: slideIn 0.3s ease-out;\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px) scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.authHeader {\n  text-align: center;\n  margin-bottom: 30px;\n\n  h2 {\n    margin: 0 0 8px 0;\n    font-size: 24px;\n    font-weight: 600;\n    color: #1053ad;\n  }\n\n  p {\n    margin: 0;\n    color: #666;\n    font-size: 14px;\n    line-height: 1.5;\n  }\n}\n\n.authForm {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.formGroup {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n\n  label {\n    font-weight: 600;\n    color: #333;\n    font-size: 14px;\n  }\n\n  input {\n    padding: 12px 16px;\n    border: 2px solid #e0e0e0;\n    border-radius: 8px;\n    font-size: 14px;\n    transition: all 0.3s ease;\n    font-family: inherit;\n\n    &:focus {\n      outline: none;\n      border-color: #1053ad;\n      box-shadow: 0 0 0 3px rgba(16, 83, 173, 0.1);\n    }\n\n    &::placeholder {\n      color: #999;\n    }\n\n    &:disabled {\n      background-color: #f5f5f5;\n      cursor: not-allowed;\n    }\n  }\n}\n\n.errorMessage {\n  background-color: #fee;\n  color: #d32f2f;\n  padding: 12px 16px;\n  border-radius: 8px;\n  border: 1px solid #ffcdd2;\n  font-size: 14px;\n  text-align: center;\n  animation: shake 0.5s ease-in-out;\n}\n\n@keyframes shake {\n  0%, 100% { transform: translateX(0); }\n  25% { transform: translateX(-5px); }\n  75% { transform: translateX(5px); }\n}\n\n.buttonGroup {\n  display: flex;\n  gap: 12px;\n  margin-top: 10px;\n}\n\n.cancelButton, .loginButton {\n  flex: 1;\n  padding: 12px 24px;\n  border: none;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n\n  &:disabled {\n    cursor: not-allowed;\n    opacity: 0.6;\n  }\n\n  &:hover:not(:disabled) {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  }\n}\n\n.cancelButton {\n  background-color: #f5f5f5;\n  color: #666;\n  border: 2px solid #e0e0e0;\n\n  &:hover:not(:disabled) {\n    background-color: #e0e0e0;\n    color: #333;\n  }\n}\n\n.loginButton {\n  background-color: #1053ad;\n  color: white;\n\n  &:hover:not(:disabled) {\n    background-color: #0d4494;\n  }\n\n  &:disabled {\n    background-color: #ccc;\n  }\n}\n\n.authTip {\n  margin-top: 20px;\n  padding: 12px;\n  background-color: #f8f9fa;\n  border-radius: 8px;\n  border-left: 4px solid #1053ad;\n\n  p {\n    margin: 0;\n    font-size: 12px;\n    color: #666;\n    text-align: center;\n  }\n}\n\n// 响应式设计\n@media (max-width: 480px) {\n  .authContainer {\n    margin: 20px;\n    padding: 30px 20px;\n  }\n\n  .authHeader {\n    h2 {\n      font-size: 20px;\n    }\n  }\n\n  .buttonGroup {\n    flex-direction: column;\n    gap: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `AdminAuth_overlay__Fu3Qe`,
	"authContainer": `AdminAuth_authContainer__79obj`,
	"slideIn": `AdminAuth_slideIn__C6QWM`,
	"authHeader": `AdminAuth_authHeader__yI1yv`,
	"authForm": `AdminAuth_authForm__RZH5f`,
	"formGroup": `AdminAuth_formGroup__4Jh8C`,
	"errorMessage": `AdminAuth_errorMessage__jEN-M`,
	"shake": `AdminAuth_shake__WmIg2`,
	"buttonGroup": `AdminAuth_buttonGroup__c+JYv`,
	"cancelButton": `AdminAuth_cancelButton__3-kq-`,
	"loginButton": `AdminAuth_loginButton__AYQUx`,
	"authTip": `AdminAuth_authTip__3FXF4`
};
export default ___CSS_LOADER_EXPORT___;
